import { useState, useEffect, useMemo } from "react";
import styles from "../SliderSection/SliderSection.module.css";
import TitleBar from "../../TitleBar/TitleBar";

const CardSlider = ({ testimonialdata = {} }) => {
  const slides = useMemo(() => {
    const list = testimonialdata.slides || [];
    return list.map((s, i) => ({
      id: s.id ?? i + 1,
      img: s.img?.src || "",
      imgAlt: s.img?.alt || `Slide ${i + 1}`,
      title: s.title || "",
      subtitle: s.subtitle || "",
      maindes: s.maindes || "",
      desc: s.desc || "",
    }));
  }, [testimonialdata]);

  const [active, setActive] = useState(0);
  const [isPaused, setIsPaused] = useState(false);

  const prevSlide = () => {
    setActive((prev) => (prev === 0 ? slides.length - 1 : prev - 1));
  };
  const nextSlide = () => {
    setActive((prev) => (prev === slides.length - 1 ? 0 : prev + 1));
  };

  useEffect(() => {
    if (!isPaused && slides.length > 1) {
      const interval = setInterval(nextSlide, 3000);
      return () => clearInterval(interval);
    }
  }, [isPaused, active, slides.length]);

  const renderMetric = (text) => {
    const parts = (text || "").trim().split(/\s+/);
    if (parts.length <= 2)
      return <span className={styles.boldtext}>{text}</span>;
    const head = parts.slice(0, -2).join(" ");
    const tail = parts.slice(-2).join(" ");
    return (
      <>
        {head} <span className={styles.boldtext}>{tail}</span>
      </>
    );
  };

  const isEnabled = testimonialdata.enabled !== false && slides.length > 0;
  if (!isEnabled) return null;

  return (
    <div
      className={styles.wrapper}
      onMouseEnter={() => setIsPaused(true)}
      onMouseLeave={() => setIsPaused(false)}
    >
      <div className={styles.TitleBarDiv}>
        <TitleBar blocks={testimonialdata?.subTitle} />
      </div>

      <div className={styles.slider}>
        {slides.map((item, index) => {
          let position = "";
          if (index === active) position = styles.activeSlide;
          else if (index === (active - 1 + slides.length) % slides.length)
            position = styles.prevSlide;
          else if (index === (active + 1) % slides.length)
            position = styles.nextSlide;
          else position = styles.hiddenSlide;

          return (
            <div key={item.id} className={`${styles.slide} ${position}`}>
              <img src={item.img} alt={item.imgAlt} />
            </div>
          );
        })}
      </div>

      <div className={styles.contentMain}>
        <div className={styles.content}>
          <span className={styles.tag}>{slides[active].title}</span>
          <h2>{slides[active].subtitle}</h2>
          <p className={styles.LightFont}>
            {renderMetric(slides[active].maindes)}
          </p>
          <p className={styles.CardDisc}>{slides[active].desc}</p>

          <div className={styles.arrowLeft} onClick={prevSlide}>
            <img src="/Svg/left-arrow.svg" alt="left-arrow" />
          </div>
          <div className={styles.arrowRight} onClick={nextSlide}>
            <img src="/Svg/right-arrow.svg" alt="right-arrow" />
          </div>
        </div>
      </div>
    </div>
  );
};

export default CardSlider;
